// Mock data for Cheapora

export const popularDestinations = [
  { id: 1, city: 'Bangkok', country: 'Thailand', code: 'BKK', price: 189, image: 'https://images.unsplash.com/photo-1563492065599-3520f775eeed', tagline: '2h 40m from Singapore' },
  { id: 2, city: 'Tokyo', country: 'Japan', code: 'TYO', price: 549, image: 'https://images.unsplash.com/photo-1542051841857-5f90071e7989', tagline: '7h non-stop' },
  { id: 3, city: 'Bali', country: 'Indonesia', code: 'DPS', price: 149, image: 'https://images.unsplash.com/photo-1555400038-63f5ba517a47', tagline: 'Island escape' },
  { id: 4, city: 'Kuala Lumpur', country: 'Malaysia', code: 'KUL', price: 69, image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07', tagline: '1h flight, weekend friendly' },
  { id: 5, city: 'London', country: 'United Kingdom', code: 'LON', price: 899, image: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad', tagline: '13h non-stop' },
  { id: 6, city: 'Paris', country: 'France', code: 'PAR', price: 949, image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34', tagline: 'City of lights' },
  { id: 7, city: 'Sydney', country: 'Australia', code: 'SYD', price: 629, image: 'https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9', tagline: '8h non-stop' },
  { id: 8, city: 'Dubai', country: 'UAE', code: 'DXB', price: 469, image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c', tagline: '7h 30m non-stop' },
];

export const airports = [
  { code: 'SIN', name: 'Singapore Changi', city: 'Singapore' },
  { code: 'BKK', name: 'Suvarnabhumi', city: 'Bangkok' },
  { code: 'DMK', name: 'Don Mueang', city: 'Bangkok' },
  { code: 'HND', name: 'Haneda', city: 'Tokyo' },
  { code: 'NRT', name: 'Narita', city: 'Tokyo' },
  { code: 'DPS', name: 'Ngurah Rai', city: 'Bali' },
  { code: 'KUL', name: 'Kuala Lumpur Intl.', city: 'Kuala Lumpur' },
  { code: 'LHR', name: 'Heathrow', city: 'London' },
  { code: 'CDG', name: 'Charles de Gaulle', city: 'Paris' },
  { code: 'SYD', name: 'Kingsford Smith', city: 'Sydney' },
  { code: 'DXB', name: 'Dubai Intl.', city: 'Dubai' },
  { code: 'HKG', name: 'Hong Kong Intl.', city: 'Hong Kong' },
  { code: 'ICN', name: 'Incheon', city: 'Seoul' },
  { code: 'TPE', name: 'Taoyuan', city: 'Taipei' },
  { code: 'MNL', name: 'Ninoy Aquino Intl.', city: 'Manila' },
  { code: 'CGK', name: 'Soekarno-Hatta', city: 'Jakarta' },
  { code: 'JFK', name: 'John F. Kennedy', city: 'New York' },
  { code: 'LAX', name: 'Los Angeles Intl.', city: 'Los Angeles' },
  { code: 'SFO', name: 'San Francisco Intl.', city: 'San Francisco' },
  { code: 'ORD', name: "O'Hare Intl.", city: 'Chicago' },
  { code: 'BOS', name: 'Logan Intl.', city: 'Boston' },
  { code: 'SEA', name: 'Seattle-Tacoma Intl.', city: 'Seattle' },
];

export const airlines = [
  { code: 'SQ', name: 'Singapore Airlines' },
  { code: 'TR', name: 'Scoot' },
  { code: 'AK', name: 'AirAsia' },
  { code: 'MH', name: 'Malaysia Airlines' },
  { code: 'TG', name: 'Thai Airways' },
  { code: 'CX', name: 'Cathay Pacific' },
  { code: 'QF', name: 'Qantas' },
  { code: 'EK', name: 'Emirates' },
  { code: 'BA', name: 'British Airways' },
  { code: 'JL', name: 'Japan Airlines' },
];

// Generate mock flight results
export const generateFlightResults = (from = 'SIN', to = 'BKK') => {
  const seed = (from.charCodeAt(0) + to.charCodeAt(0)) % 7;
  return [
    {
      id: 'f1', airline: 'Singapore Airlines', code: 'SQ', logo: 'SQ',
      depart: '08:15', arrive: '09:45', duration: '2h 30m', stops: 'Non-stop',
      from, to, price: 289 + seed * 12, cabin: 'Economy', emissions: 'Lower emissions'
    },
    {
      id: 'f2', airline: 'Scoot', code: 'TR', logo: 'TR',
      depart: '06:30', arrive: '08:05', duration: '2h 35m', stops: 'Non-stop',
      from, to, price: 149 + seed * 8, cabin: 'Economy', emissions: null
    },
    {
      id: 'f3', airline: 'Thai Airways', code: 'TG', logo: 'TG',
      depart: '11:20', arrive: '12:55', duration: '2h 35m', stops: 'Non-stop',
      from, to, price: 259 + seed * 10, cabin: 'Economy', emissions: null
    },
    {
      id: 'f4', airline: 'AirAsia', code: 'AK', logo: 'AK',
      depart: '14:45', arrive: '18:20', duration: '4h 35m', stops: '1 stop · KUL',
      from, to, price: 129 + seed * 6, cabin: 'Economy', emissions: null
    },
    {
      id: 'f5', airline: 'Malaysia Airlines', code: 'MH', logo: 'MH',
      depart: '17:10', arrive: '20:45', duration: '4h 35m', stops: '1 stop · KUL',
      from, to, price: 199 + seed * 9, cabin: 'Economy', emissions: null
    },
    {
      id: 'f6', airline: 'Cathay Pacific', code: 'CX', logo: 'CX',
      depart: '19:30', arrive: '00:15', duration: '5h 45m', stops: '1 stop · HKG',
      from, to, price: 319 + seed * 11, cabin: 'Economy', emissions: 'Lower emissions'
    },
    {
      id: 'f7', airline: 'Singapore Airlines', code: 'SQ', logo: 'SQ',
      depart: '22:00', arrive: '23:30', duration: '2h 30m', stops: 'Non-stop',
      from, to, price: 269 + seed * 12, cabin: 'Economy', emissions: 'Lower emissions'
    },
  ];
};

export const hotels = [
  { id: 'h1', name: 'Marina Bay Sands', city: 'Singapore', rating: 4.8, reviews: 12480, price: 528, image: 'https://images.unsplash.com/photo-1540541338287-41700207dee6', amenities: ['Pool','Spa','Free WiFi','Breakfast'] },
  { id: 'h2', name: 'The Ritz-Carlton Bangkok', city: 'Bangkok', rating: 4.7, reviews: 8930, price: 289, image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945', amenities: ['Pool','Spa','Free WiFi','Gym'] },
  { id: 'h3', name: 'Park Hyatt Tokyo', city: 'Tokyo', rating: 4.9, reviews: 5670, price: 612, image: 'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4', amenities: ['Spa','Gym','Free WiFi','Bar'] },
  { id: 'h4', name: 'Four Seasons Resort Bali', city: 'Bali', rating: 4.9, reviews: 4120, price: 749, image: 'https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9', amenities: ['Beach','Pool','Spa','Breakfast'] },
  { id: 'h5', name: 'The Peninsula Paris', city: 'Paris', rating: 4.8, reviews: 3890, price: 892, image: 'https://images.unsplash.com/photo-1445019980597-93fa8acb246c', amenities: ['Spa','Bar','Free WiFi','Concierge'] },
  { id: 'h6', name: 'Burj Al Arab', city: 'Dubai', rating: 4.9, reviews: 9450, price: 1289, image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c', amenities: ['Beach','Pool','Spa','Butler'] },
];

export const cars = [
  { id: 'c1', model: 'Toyota Corolla', category: 'Compact', seats: 5, transmission: 'Auto', bags: 2, price: 45, image: 'https://images.unsplash.com/photo-1590362891991-f776e747a588', vendor: 'Hertz' },
  { id: 'c2', model: 'Honda Civic', category: 'Mid-size', seats: 5, transmission: 'Auto', bags: 3, price: 58, image: 'https://images.unsplash.com/photo-1552519507-da3b142c6e3d', vendor: 'Avis' },
  { id: 'c3', model: 'Toyota Alphard', category: 'MPV', seats: 7, transmission: 'Auto', bags: 5, price: 129, image: 'https://images.unsplash.com/photo-1519641471654-76ce0107ad1b', vendor: 'Sixt' },
  { id: 'c4', model: 'BMW 3 Series', category: 'Premium', seats: 5, transmission: 'Auto', bags: 3, price: 149, image: 'https://images.unsplash.com/photo-1555215695-3004980ad54e', vendor: 'Europcar' },
  { id: 'c5', model: 'Mercedes-Benz E-Class', category: 'Luxury', seats: 5, transmission: 'Auto', bags: 3, price: 189, image: 'https://images.unsplash.com/photo-1563720223185-11003d516935', vendor: 'Hertz' },
  { id: 'c6', model: 'Ford Ranger', category: 'SUV', seats: 5, transmission: 'Auto', bags: 4, price: 98, image: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf', vendor: 'Budget' },
];

export const deals = [
  { id: 'd1', title: 'Maldives Overwater Villa', category: 'Beach Escape', nights: 5, price: 1899, savings: 32, image: 'https://images.unsplash.com/photo-1540541338287-41700207dee6', location: 'Maldives' },
  { id: 'd2', title: 'Swiss Alps Mountain Retreat', category: 'Mountain', nights: 7, price: 2299, savings: 25, image: 'https://images.unsplash.com/photo-1770932345647-ca6f3ddd6309', location: 'Switzerland' },
  { id: 'd3', title: 'New York City Break', category: 'City', nights: 4, price: 1499, savings: 18, image: 'https://images.unsplash.com/photo-1519121785383-3229633bb75b', location: 'USA' },
  { id: 'd4', title: 'Mediterranean Cruise', category: 'Cruise', nights: 8, price: 2149, savings: 28, image: 'https://images.unsplash.com/photo-1554254648-2d58a1bc3fd5', location: 'Europe' },
];

export const blogPosts = [
  { id: 'b1', title: '15 Insider Tips for First-Time Travellers to Japan', excerpt: 'From navigating Tokyo\'s train system to ryokan etiquette — everything you need to know.', category: 'Travel Tips', readTime: 8, date: 'Jun 24, 2025', image: 'https://images.unsplash.com/photo-1496950866446-3253e1470e8e' },
  { id: 'b2', title: 'The Ultimate Carry-On Packing Guide', excerpt: 'Pack smarter, not heavier. Our editors share their favourite carry-on essentials.', category: 'Packing', readTime: 6, date: 'Jun 18, 2025', image: 'https://images.unsplash.com/photo-1502301197179-65228ab57f78' },
  { id: 'b3', title: 'How to Fly to Europe for Under S$700', excerpt: 'Timing, routing and airline tricks that unlock huge savings on long-haul flights.', category: 'Budget Travel', readTime: 10, date: 'Jun 10, 2025', image: 'https://images.unsplash.com/photo-1524850011238-e3d235c7d4c9' },
  { id: 'b4', title: 'Family-Friendly Escapes Within 5 Hours of Singapore', excerpt: 'Short-haul destinations perfect for kids — beaches, theme parks and nature parks.', category: 'Family', readTime: 7, date: 'Jun 03, 2025', image: 'https://images.unsplash.com/photo-1506836467174-27f1042aa48c' },
];

export const testimonials = [
  { id: 't1', name: 'Priya S.', location: 'Singapore', rating: 5, text: 'Booked our family trip to Bali through Cheapora — smooth process and the best fare we found anywhere.' },
  { id: 't2', name: 'Marcus T.', location: 'Singapore', rating: 5, text: 'Their team helped me sort out a last-minute flight change to Tokyo. Genuine, responsive service.' },
  { id: 't3', name: 'Aisha R.', location: 'Singapore', rating: 5, text: 'I compared prices everywhere — Cheapora consistently came in cheaper for our honeymoon package.' },
];

export const trustBadges = [
  { label: 'STB Licensed \u00b7 TA03795' },
  { label: 'Local Singapore Support' },
];
